export default {
    name: 'ArrowDiagonalDown',
    dimensions: { width: 14, height: 14 },
    content: `<path fill-rule="evenodd" clip-rule="evenodd" d="M13.7071 0.292896C14.0976 0.68342 14.0976 1.31659 13.7071 1.70711L3.41421 12L10 12C10.5523 12 11 12.4477 11 13C11 13.5523 10.5523 14 10 14L0.999998 14C0.447713 14 -2.25035e-06 13.5523 -2.15378e-06 13L-6.99382e-07 4C-7.22027e-07 3.44772 0.447715 3 1 3C1.55228 3 2 3.44772 2 4L2 10.5858L12.2929 0.292895C12.6834 -0.0976289 13.3166 -0.0976288 13.7071 0.292896Z" fill="currentColor"/>`
};
